import { Box, Container, Typography, Card, CardContent } from '@mui/material'

export default function Features() {
  const features = [
    {
      icon: '📱',
      title: 'PWA Cliente',
      description: 'Interface intuitiva para clientes solicitarem garçom, pedir conta ou acessar cardápio',
    },
    {
      icon: '🏃',
      title: 'PWA Garçom',
      description: 'Notificações em tempo real com localização exata de cada mesa',
    },
    {
      icon: '🍳',
      title: 'Web Cozinha',
      description: 'Dashboard visual intuitivo com status de todas as mesas',
    },
    {
      icon: '⚡',
      title: 'Ultra Rápido',
      description: 'Resposta em menos de 2 segundos, otimizado para velocidade',
    },
    {
      icon: '📊',
      title: 'Analytics',
      description: 'Relatórios detalhados sobre tempo de atendimento e satisfação',
    },
    {
      icon: '🚀',
      title: 'Escalável',
      description: 'Cresce automaticamente com seu negócio sem limites técnicos',
    },
  ]

  const benefits = [
    { icon: '🔐', title: 'Seguro', desc: 'Banco de dados seguro' },
    { icon: '🌍', title: 'Global', desc: 'Funciona em qualquer lugar' },
    { icon: '💰', title: 'Econômico', desc: 'Sem custos ocultos' },
    { icon: '🛠️', title: 'Suporte', desc: '24/7 disponível' },
  ]

  return (
    <Box
      component="section"
      id="features"
      sx={{
        py: { xs: 10, md: 20 },
        px: { xs: 2, sm: 3, lg: 4 },
        background: 'linear-gradient(180deg, transparent 0%, #f9fafb 100%)',
      }}
    >
      <Container maxWidth="lg" sx={{ pt: 0 }}>
        {/* Section Title */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: '2.25rem', md: '3.75rem' },
              fontWeight: 900,
              color: '#1f2937',
              mb: 2,
            }}
          >
            Funcionalidades Poderosas
          </Typography>
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: '1rem', md: '1.1rem' },
              color: '#6b7280',
              maxWidth: '700px',
              mx: 'auto',
              textAlign: 'center',
            }}
          >
            Tudo integrado em uma plataforma moderna para revolucionar a gestão do seu restaurante
          </Typography>
        </Box>

        {/* Features Grid - 6 Cards em 2 linhas */}
        <Box 
          sx={{ 
            display: 'grid', 
            gridTemplateColumns: { xs: '1fr', md: '1fr 1fr 1fr' }, 
            gap: 4, 
            mb: 10 
          }}
        >
          {features.map((feature) => (
            <Card
              key={feature.title}
              elevation={0}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                height: '100%',
                border: '1px solid #e5e7eb',
                borderRadius: '1rem',
                background: 'rgba(255, 255, 255, 0.5)',
                transition: 'all 0.3s ease',
                cursor: 'pointer',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
                  borderColor: '#dc2626',
                },
              }}
            >
              <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Typography sx={{ fontSize: '2.5rem', mb: 2, flexShrink: 0 }}>
                  {feature.icon}
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    fontWeight: 700,
                    color: '#1f2937',
                    mb: 1.5,
                    fontSize: '1rem',
                    flexShrink: 0,
                  }}
                >
                  {feature.title}
                </Typography>
                <Typography
                  sx={{
                    color: '#6b7280',
                    lineHeight: 1.6,
                    fontSize: '0.9rem',
                    flex: 1,
                  }}
                >
                  {feature.description}
                </Typography>
              </CardContent>
            </Card>
          ))}
        </Box>

        {/* Extra Benefits */}
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr 1fr', md: 'repeat(4, minmax(0, 1fr))' }, gap: 2, maxWidth: '800px', mx: 'auto' }}>
          {benefits.map((benefit) => (
            <Box
              key={benefit.title}
              sx={{
                textAlign: 'center',
                p: 2,
                borderRadius: '1rem',
                '&:hover': {
                  backgroundColor: '#fef2f2',
                },
                transition: 'all 0.3s ease',
              }}
            >
              <Typography sx={{ fontSize: '2rem', mb: 1 }}>
                {benefit.icon}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 700,
                  color: '#1f2937',
                  mb: 0.5,
                }}
              >
                {benefit.title}
              </Typography>
              <Typography
                sx={{
                  fontSize: '0.875rem',
                  color: '#6b7280',
                }}
              >
                {benefit.desc}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  )
}
